import React, { useEffect, useState } from "react";
import avatar from "../../assests/icons/Oval.png";
import { Dropdown, Spin } from "antd";
import { BiLogOut } from "react-icons/bi";
import axios from "axios";
import { BASE_URL } from "../../utils/config";
import { useNavigate } from "react-router";
import { BsBell } from "react-icons/bs";
import { RiMenu2Fill } from "react-icons/ri";
import { chnageTheme } from "../../redux/reducer/themeSlice";
import { useDispatch, useSelector } from "react-redux";
import { FaEyeSlash, FaRegEye } from "react-icons/fa";
import { FaRegUser } from "react-icons/fa6";
import { IoChevronUpOutline, IoChevronDownOutline } from "react-icons/io5";
import handleGet from "../../utils/Get";
import handlePost from "../../utils/Post";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
import { Link } from "react-router-dom";

// ── Languages list ────────────────────────────────────────────────────────────
const languages = [
  { code: "en", label: "English", flag: "https://flagcdn.com/w40/us.png" },
  { code: "fr", label: "French",  flag: "https://flagcdn.com/w40/fr.png" },
  { code: "de", label: "German",  flag: "https://flagcdn.com/w40/de.png" },
];

const UserHeader = ({ setShowSiderbar }) => {
  const { t } = useTranslation();
  const transData = t("Select", { returnObjects: true });
  const navigate = useNavigate();
  const title = useSelector((state) => state.header.title);
  const dispatch = useDispatch();
  const theme = useSelector((state) => state?.theme?.value);
  const avatar1 = `${window.location.origin}/avatar1.png`;
  const userData = JSON.parse(localStorage.getItem("user") || "{}");
  const userEmail = userData?.email || "testing@yopmail.com";
  const userName = userData?.name || "testing";
  const userInitial = userName?.charAt(0)?.toUpperCase() || "T";

  const [loader, setloader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [UserNotification, setnotification] = useState([]);
  const [userDropOpen, setUserDropOpen] = useState(false);
  const [activeLang, setActiveLang] = useState(languages[0]);
  const [isSm, setIsSm] = useState(window.innerWidth >= 640);

  useEffect(() => {
    const handleResize = () => setIsSm(window.innerWidth >= 640);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogout = async () => {
    setloader(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${BASE_URL}logout`, {
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
          type: "Bearer",
        },
      });
      localStorage.removeItem("token");
      localStorage.removeItem("timestamp");
      localStorage.removeItem("time");
      navigate("/login");
    } catch (err) {
      console.log(err);
    } finally {
      setloader(false);
    }
  };

  const fetchNotification = async () => {
    try {
      const data = await handleGet(`${BASE_URL}active/user/notification`);
      setnotification(data?.data || []);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  useEffect(() => {
    fetchNotification();
    const intervalId = setInterval(fetchNotification, 1800000);
    return () => clearInterval(intervalId);
  }, []);

  const HandleRead = async (id, currentStatus) => {
    try {
      const newStatus = currentStatus === false ? "1" : "0";
      const response = await handlePost(`${BASE_URL}get/notifications/${id}`, {
        status: newStatus,
      });
      if (response) fetchNotification();
    } catch (error) {
      console.log(error);
    }
  };

  const unreadCount =
    UserNotification?.filter((n) => n?.status === false)?.length || 0;

  const changeLanguageWithLoader = (language) => {
    setLoading(true);
    const lang = languages.find((l) => l.code === language);
    if (lang) setActiveLang(lang);
    setTimeout(() => {
      setLoading(false);
      i18n.changeLanguage(language);
    }, 1000);
  };

  const RoundBtn = ({ children, onClick, className = "" }) => (
    <button
      onClick={onClick}
      className={`
        w-10 h-10 rounded-full flex items-center justify-center cursor-pointer
        bg-[#1a2236] hover:bg-[#1e2942]
        text-white/60 hover:text-white
        transition-all duration-200
        ${className}
      `}
    >
      {children}
    </button>
  );

  return (
    <div className="w-full flex items-center justify-between gap-4 rounded-b-2xl px-3 py-4 mt-10 bg-[#0b1629] dark:bg-[#0b1629] shadow-md dark:shadow-[0_20px_45px_rgba(0,0,0,.9)]">

      {/* LEFT: Hamburger + Title */}
      <div className="flex items-center gap-3 min-w-0">
        <button
          className="xl:hidden text-white/50 hover:text-white transition-colors flex-shrink-0"
          onClick={() => setShowSiderbar(true)}
        >
          <RiMenu2Fill size={22} />
        </button>
        <div>
          <h1 className="text-xl font-bold text-white leading-tight">
            {title || "Dashboard"}
          </h1>
          <p className="text-xs text-white/80 mt-0.5">
            Overview of your account activity
          </p>
        </div>
      </div>

      {/* RIGHT */}
      <div className="flex items-center gap-3 flex-shrink-0">

        {/* Language */}
        <Dropdown
          placement="bottomLeft"
          trigger={["click"]}
          dropdownRender={() => (
            <ul className="bg-[#1a2236] rounded-xl shadow-2xl py-1.5 px-1.5 z-[1000] w-44 mt-2">
              {[
                { code: "en", label: transData?.first  || "English", flag: "https://flagcdn.com/w40/us.png" },
                { code: "de", label: transData?.second || "German",  flag: "https://flagcdn.com/w40/de.png" },
                { code: "fr", label: transData?.third  || "French",  flag: "https://flagcdn.com/w40/fr.png" },
              ].map(({ code, label, flag }) => (
                <li
                  key={code}
                  onClick={() => changeLanguageWithLoader(code)}
                  className="flex items-center gap-2.5 px-3 py-2 rounded-lg cursor-pointer text-white/80 hover:text-white hover:bg-white/8 transition-all duration-150 text-sm"
                >
                  <img src={flag} className="w-5 h-3.5 object-cover rounded-sm flex-shrink-0" alt={label} />
                  {label}
                </li>
              ))}
            </ul>
          )}
        >
          <button className="hidden min-[525px]:flex items-center gap-1.5 px-3 py-2 rounded-full cursor-pointer bg-[#1a2236] hover:bg-[#1e2942] text-white/80 hover:text-white text-sm font-medium transition-all duration-200">
            {loading ? (
              <div className="w-4 h-4 rounded-full border-2 border-white/40 border-t-white animate-spin" />
            ) : (
              <>
                <img src={activeLang.flag} className="w-5 h-3.5 object-cover rounded-sm flex-shrink-0" alt={activeLang.code} />
                <span>{activeLang.code.toUpperCase()}</span>
              </>
            )}
          </button>
        </Dropdown>

        {/* Bell */}
        <Dropdown
          placement="bottomLeft"
          trigger={["click"]}
          dropdownRender={() => (
            <div className="bg-[#1a2236] rounded-2xl shadow-2xl z-[1000] w-[380px] max-h-[320px] overflow-hidden flex flex-col mt-2">
              <div className="px-4 py-3 border-b border-white/8 flex-shrink-0">
                <h3 className="text-sm font-semibold text-white">Notifications</h3>
                <p className="text-xs text-white/80 mt-0.5">
                  You have {unreadCount} unread notification{unreadCount !== 1 ? "s" : ""}
                </p>
              </div>
              <ul className="overflow-y-auto divide-y divide-white/5">
                {UserNotification?.length === 0 && (
                  <li className="py-8 text-center text-white/80 text-sm">No notifications</li>
                )}
                {UserNotification?.map((item, index) => (
                  <li key={index} className={`flex items-start gap-3 px-4 py-3 ${item?.status !== false ? "opacity-40" : ""}`}>
                    <img src={item?.user?.avatar_url || avatar1} className="w-9 h-9 rounded-full object-cover flex-shrink-0 mt-0.5" alt="avatar" />
                    <p className="text-xs text-white/80 flex-1 capitalize leading-relaxed mt-1">{item?.message}</p>
                    <button
                      className="text-white/80 hover:text-white transition-colors mt-1 flex-shrink-0"
                      onClick={() => HandleRead(item?.id, item?.status)}
                    >
                      {item?.status === false ? <FaEyeSlash size={15} /> : <FaRegEye size={15} />}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}
        >
          <div className="relative hidden min-[525px]:block">
            <RoundBtn>
              <BsBell size={17} />
            </RoundBtn>
            {unreadCount > 0 && (
              <span className="absolute -top-0.5 -right-0.5 w-4 h-4 rounded-full bg-violet-500 text-white text-[9px] font-bold flex items-center justify-center">
                {unreadCount > 9 ? "9+" : unreadCount}
              </span>
            )}
          </div>
        </Dropdown>

        {/* User pill */}
        <Dropdown
          placement="bottomLeft"
          trigger={["click"]}
          onOpenChange={(open) => setUserDropOpen(open)}
          dropdownRender={() => (
            <div className="bg-[#1a2236] rounded-2xl shadow-2xl z-[1000] w-52 overflow-hidden mt-2">
              <div className="px-4 py-3.5 border-b border-white/8">
                <p className="text-sm font-semibold text-white">{userName}</p>
                <p className="text-xs text-white/80 truncate mt-0.5">{userEmail}</p>
              </div>
              <div className="p-1.5 space-y-0.5">
                <Link to={'/user/profile'} className="w-full flex items-center gap-2.5 px-3 py-2.5 text-sm text-white/80 hover:text-white hover:bg-white/6 rounded-xl transition-all duration-150">
                  <FaRegUser size={14} className="flex-shrink-0" />
                  Account Settings
                </Link>
              </div>
              <div className="p-1.5 border-t border-white/8">
                <button
                  onClick={handleLogout}
                  className="w-full flex items-center gap-2.5 px-3 py-2.5 text-sm text-red-400 hover:text-red-300 hover:bg-red-500/8 rounded-xl transition-all duration-150"
                >
                  {loader ? <Spin size="small" /> : <BiLogOut size={15} className="flex-shrink-0" />}
                  Logout
                </button>
              </div>
            </div>
          )}
        >
          <button className="flex items-center gap-2.5 pl-1.5 pr-3 py-1.5 rounded-full cursor-pointer bg-[#1a2236] hover:bg-[#1e2942] transition-all duration-200">
            <div className="w-7 h-7 rounded-full bg-violet-600 flex items-center justify-center text-white text-xs font-bold flex-shrink-0">
              {userInitial}
            </div>
            {isSm && (
              <div className="flex flex-col text-left leading-tight ml-2">
                <span className="text-xs font-semibold text-white">{userName}</span>
                <span className="text-[10px] text-white/80 truncate max-w-[110px]">{userEmail}</span>
              </div>
            )}
            {userDropOpen
              ? <IoChevronUpOutline size={12} className="text-white/80 ml-0.5" />
              : <IoChevronDownOutline size={12} className="text-white/80 ml-0.5" />
            }
          </button>
        </Dropdown>

      </div>
    </div>
  );
};

export default UserHeader;